import React from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { useQuery } from '@apollo/client';
import { withRouter } from 'react-router';
import query from '@catalogo/core-queries/skin.graphql';

export const Skin = ({ children, history }) => {
  const { data } = useQuery(query, { variables: { path: history.location.pathname }, fetchPolicy: 'cache-only' });
  const fontColor = getIn(data, ['skin', 'textLight']) === 'texto claro' ? '#fff' : null;
  const bgColor = getIn(data, ['skin', 'bgColor']);

  return (
    <SkinUI $fontColor={fontColor} $bgColor={bgColor}>
      {children}
    </SkinUI>
  );
};

export default withRouter(Skin);

const SkinUI = styled.div`
  background: ${({ $bgColor }) => $bgColor || 'inherit'};
  color: ${({ $fontColor }) => $fontColor || 'inherit'};
`;
